
import { UserCache } from "../../caches";
import { BaseClientService } from "../base-client.service";
import { ControllerOptions, DataController } from "../../../types";
import { AppUser , UserProfile, UserProfileService, UserService } from "@nt-portal/server-sdk";

export interface UserProfileOptions extends ControllerOptions<UserProfile> {

}


export class ClientUserProfileService extends BaseClientService {

    private _service: UserProfileService;

    constructor() {
        super();
        this._service = new UserProfileService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async getMe() {

        let user = await this._service.get(this.token) ;
        return user;


    }


    public async update(profile: UserProfile) {
        return await this._service.update(profile, this.token);
    }









}